module.exports = __webpack_public_path__ + "img/314e251f95cad1c89e82e0c267be5805c83d51a1.6997e513.png";